import { render } from "./AppIntro.vue?vue&type=template&id=c244c306&scoped=true"
import script from "./AppIntro.vue?vue&type=script&lang=js"
export * from "./AppIntro.vue?vue&type=script&lang=js"

import "./AppIntro.vue?vue&type=style&index=0&id=c244c306&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c244c306"]])

export default __exports__